<template>
    <div
        class="flex flex-row items-start justify-start gap-3 rounded-md bg-sky-100 p-4 text-sm text-sky-800"
    >
        <font-awesome-icon widthAuto :icon="props.icon" class="mt-1 text-sky-500" />

        <div class="w-full space-y-2">
            <slot></slot>

            <div
                v-if="props.activeBlock !== -1"
                class="flex w-full flex-row gap-1 overflow-hidden rounded-full"
            >
                <div
                    v-for="n in props.blocks"
                    :key="n"
                    class="h-1 w-full"
                    :class="{
            'bg-sky-200': n > props.activeBlock,
            'bg-sky-500': n <= props.activeBlock,
            'animate-[pulse_1s_cubic-bezier(0.4,0,0.6,1)_infinite]':
              n === props.activeBlock,
          }"
                ></div>
            </div>

            <div
                v-if="props.activeBlock === -1"
                class="flex w-full flex-row gap-1 overflow-hidden rounded-full"
            >
                <div class="h-1 w-full bg-sky-200"></div>
            </div>

            <figure>
                <figcaption class="text-sky-500">
                    <slot name="caption"></slot>
                </figcaption>
            </figure>
        </div>
    </div>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const props = defineProps({
    blocks: {
        type: Number,
        required: false,
    },
    activeBlock: {
        type: Number,
        required: false,
    },
    icon: {
        type: Object,
        required: true,
    },
})
</script>
